import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FaqCategoryService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl: string;

  constructor() {
    this._apiUrl = environment.apiUrl;
  }

  find(): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/category`);
  }

  create(data: any): Observable<any> {
    return this._http.post<any>(`${this._apiUrl}/createCategory`, data);
  }

  update(id: number, data: any): Observable<any> {
    return this._http.put<any>(`${this._apiUrl}/category/${id}`, data);
  }

  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${this._apiUrl}/category/${id}`);
  }
}
